import {CardHeader} from "@mui/material";

export const MUIOptItemCardMultipleHeader: React.FC<{ name: string, backgroundColor?: string }> = (props) => {
    const {name, backgroundColor} = props;
    return <CardHeader sx={{height: "48px", width: "100%", padding: 0, backgroundColor: backgroundColor ?? "#eeeeee"}} title={name}
                       titleTypographyProps={{variant: "body1", ml: 2, style: {fontSize: "18px", fontWeight: "500"}}}>
    </CardHeader>;
}